import {Component, OnInit} from '@angular/core';
import {SelectComponent} from '../../../core/components/edit-component';
import {RoleEditModalComponent} from '../role-edit-modal/role-edit-modal.component';
import {RoleEntity} from "../role.entity";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'mes-role-select',
  templateUrl: './role-select.component.html',
  styles: []
})
export class RoleSelectComponent extends SelectComponent<RoleEntity> implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    this.refreshToken$.next(undefined);
  }

  addNew(searchTerm: string = null) {
    const data = {initialState: {entityName: searchTerm}};
    this.startEdit(data);
  }

  edit(role: RoleEntity = null) {
    const entityId = role ? role.Id : this.entityIds[0];
    const data = {initialState: {entityId: entityId}};
    this.startEdit(data);
  }

  private startEdit(data: { initialState: { entityId?: string, entityName?: string } }) {
    this.modalService
      .show(RoleEditModalComponent, data).content.onHide$.pipe(takeUntil(this.componentDestroyed))
      .subscribe(({data: id}) => {
        let result = this.entityIds ? [...this.entityIds] : [];
        if (!id) {
          result = result.filter(value => value != data.initialState.entityId);
        } else if (!this.entityIds.includes(id)) {
          result.push(id);
        }
        this.entityIdsChange.emit(result);
        this.refreshToken$.next(undefined);
      });
  }

  onSelectionChanged($event: any) {
    if ($event && $event.length) {
      this.entityIdsChange.emit($event.map(value => value.Id));
    } else {
      this.entityIdsChange.emit([]);
    }
  }
}
